<template>

        <v-card>
            <v-card-title
                    class="v-card__title--primary primary white--text"

            >
                <h3>Delete {{title}}</h3>
            </v-card-title>

            <v-card-text>
                <p>Are you sure you want to delete {{title}}</p>
                <p v-if="deleteCheckValue">Write down the bot name to confirm</p>
                <v-text-field v-if="deleteCheckValue" outline v-model="deleteCheck" />
            </v-card-text>



            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        color="primary"
                        arge round flat
                        @click="$emit('closeDialog')"
                >
                    Cancel
                </v-btn>
                <v-btn
                        :disabled="deleteCheck !== deleteCheckValue"
                        color="error"
                        arge round
                        @click="$emit('onDelete')"
                >
                    Delete
                </v-btn>
            </v-card-actions>
        </v-card>

</template>

<script>
    export default {
        name: "deleteDialog",
        props: {
            title: {
                type: String,
                default: ()=> {
                    return  'Group'
                },
            },
            deleteCheckValue: {
                type: String,
                default: ()=> {
                    return ''
                }
            }
        },
        data() {
            return {
                deleteCheck: ''
            }
        }
    }
</script>

<style scoped>

</style>
